import type { StaticDataChartWidgetData } from '@/features/_shared/widget-registry';
import type { StaticDataChartWidgetV2, MarketApps } from '@/features/dashboard';

export function buildStaticDataChartTemplate(data: StaticDataChartWidgetData): MarketApps {
  const templateId = data.widgetId ?? data.tool_call_id;
  const tab: StaticDataChartWidgetV2 = {
    id: `ai-chat-static-data-chart-tab-${templateId}`,
    name: data.title ?? 'Static data chart',
    type: 'graph',
    metadata: { graphType: 'static' },
    tool_call_id: data.tool_call_id,
    chartConfig: data.chartConfig
  };

  return [{ id: `ai-chat-static-data-chart-${templateId}`, tabs: [tab] }];
}
